import { useState, useEffect, FormEvent } from 'react';
import { useApp } from '../../context/AppContext';

export function useSearchAPI(onProductClick?: (p: any) => void) {
  const { allProducts, searchQuery, setSearchQuery, activeTab, setActiveTab, lang } = useApp();
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    const handleOpenSearch = () => {
      setShowSuggestions(true);
    };
    window.addEventListener('open-search-overlay', handleOpenSearch);
    return () => window.removeEventListener('open-search-overlay', handleOpenSearch);
  }, []);
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchHistory, setSearchHistory] = useState<string[]>(() => {
    try { return JSON.parse(localStorage.getItem('priyofy_search_history') || '[]'); } catch { return []; }
  });

  const addToHistory = (term: string) => {
    const clean = term.trim();
    if (!clean) return;
    const updated = [clean, ...searchHistory.filter(h => h.toLowerCase() !== clean.toLowerCase())].slice(0, 5);
    setSearchHistory(updated);
    localStorage.setItem('priyofy_search_history', JSON.stringify(updated));
  };

  const clearHistory = () => { setSearchHistory([]); localStorage.removeItem('priyofy_search_history'); };
  const removeHistoryItem = (item: string) => {
    const updated = searchHistory.filter(h => h !== item);
    setSearchHistory(updated);
    localStorage.setItem('priyofy_search_history', JSON.stringify(updated));
  };

  // Exact matching helper
  const findMatches = (q: string) => {
    q = q.toLowerCase().trim();
    return allProducts.filter((p: any) => 
      p.nameEn.toLowerCase().includes(q) || p.nameBn.toLowerCase().includes(q) ||
      p.categoryEn.toLowerCase().includes(q) || p.categoryBn.toLowerCase().includes(q)
    );
  };

  useEffect(() => {
    if (!searchQuery.trim()) {
      setSuggestions([]);
      setIsSearching(false);
      return;
    }
    setIsSearching(true);
    const timeoutId = setTimeout(() => {
      setSuggestions(findMatches(searchQuery).slice(0, 8));
      setIsSearching(false);
    }, 150);
    return () => clearTimeout(timeoutId);
  }, [searchQuery, allProducts]);

  const executeSearch = (val: string) => {
    setSearchQuery(val);
    setShowSuggestions(true);
  };

  const handleSuggestionClick = (p: any) => {
    const pName = lang === 'en' ? p.nameEn : p.nameBn;
    setSearchQuery(pName); addToHistory(pName); setShowSuggestions(false);
    if (onProductClick) onProductClick(p); else setActiveTab('search');
  };

  const handleTagClick = (term: string) => {
    setSearchQuery(term); addToHistory(term); setIsSearching(true); setShowSuggestions(true);
    setSuggestions(findMatches(term).slice(0, 6)); setIsSearching(false);
    if (activeTab !== 'search') setActiveTab('search');
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) addToHistory(searchQuery);
    setShowSuggestions(false);
    if (activeTab !== 'search') setActiveTab('search');
  };

  return {
    searchQuery, executeSearch, showSuggestions, setShowSuggestions, suggestions,
    isSearching, searchHistory, addToHistory, clearHistory, removeHistoryItem,
    handleSuggestionClick, handleTagClick, handleSubmit, lang
  };
}
